export default [
  // 微信扫码登录，公用页面
  {
    name: 'WxScanCode',
    path: '/external/wx-scan-code',
    component: () => import('@/pages/external/WxScanCode/index.vue'),
    meta: {
      title: '供应商登录',
    },
  },
]
